import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {GetBasketRecommendationsResponse_Recommendation} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/recommendations/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {useTrackFeature} from '@aboutyou/tracking';
import {COLORS, TopOneHundredImage} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {InteractiveProductTile} from '../../../features/ProductTile/InteractiveProductTile';
import {RecommendationsLane} from '../../../features/Recommendations/RecommendationsLane';
import {TextBanner} from '../../../features/Recommendations/shared';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import MenImage from './assets/men.jpg';
import WomenImage from './assets/women.jpg';

interface ViewProps {
  className?: string;
  recommendation?: GetBasketRecommendationsResponse_Recommendation;
  streamPosition?: number;
  onClickAddToBasket: (productId: number | undefined) => void;
}

export const BasketFlyoutRecommendationView: React.FC<ViewProps> = ({
  className,
  recommendation,
  onClickAddToBasket,
}) => {
  const {t} = useTranslation();

  const trackFeature = useTrackFeature();

  const targetGroupIdentifier = useTargetGroupIdentifier();

  if (!recommendation) {
    trackFeature({eventType: 'impression', label: 'basketFlyout_no_recos'});
    const image =
      targetGroupIdentifier === TargetGroup.MALE ? MenImage : WomenImage;
    const url =
      targetGroupIdentifier === TargetGroup.MALE
        ? '/c/men/top-100-657009'
        : '/c/women/top-100-657008';
    return (
      <TopOneHundredImage
        image={image}
        navigationUrl={url}
        imageText={t('Discover our 100 most popular products')}
        title={t('Explore our Top 100')}
      />
    );
  }

  return (
    <>
      <ScrollWrapper className={className}>
        <StyledTextBanner
          headline={recommendation.headline}
          subline={recommendation.subline}
          isSmallFormat
        />
        <StyledRecommendationsLane
          uniqueKey="basket_flyout_reco"
          data-testid="basketRecoLane-0"
          streamPosition={0}
          type="grid"
          products={recommendation.products}
          addToCTALabel={t('Add')}
          ProductTileComponent={InteractiveProductTile}
          onAddToBasketCtaClick={({productId}) => {
            trackFeature({
              eventType: 'click',
              label: 'basketFlyout_selectItem',
            });
            onClickAddToBasket(productId);
          }}
          trackComponentConfig={{
            location_id: 'basket_flyout',
            page_type_id: 'basket',
          }}
          featureGenericClickLabel="basketFlyout_selectItem"
          productTileConfig={{gridColumns: 2}}
          columns={{small: 2, medium: 2, large: 2}}
        />
      </ScrollWrapper>
    </>
  );
};

const StyledRecommendationsLane = styled(RecommendationsLane)`
  margin-bottom: 0;
`;

export const StyledTextBanner = styled(TextBanner)`
  padding: 0 8px;
`;

const ScrollWrapper = styled.div`
  border-top: solid 1px ${COLORS.Grey3};
  padding-top: 20px;
  height: 100%;
  overflow: auto;
`;
